import { QueryClient } from "@tanstack/react-query";
import useCloudPermissions from "../hooks/useCloudPermissions";
import useWorkspacePermissions from "../hooks/useWorkspacePermissions";
import { CloudApp } from "../types/GlobalInterfaces";

export default class CloudAppUtils {
  // Handles adding a page to the cloudApps key
  static addCloudAppToCloudApps = (
    tenantID: string,
    queryClient: QueryClient,
    newCloudApp: CloudApp
  ) => {
    queryClient.setQueryData<Array<CloudApp>>(
      ["cloudApps", tenantID],
      (prevCloudApps) => {
        if (prevCloudApps === undefined) return;

        return [...prevCloudApps, newCloudApp];
      }
    );
  };

  // Handles delete cloud app in cloud apps key
  static unpublishCloudAppInCloudApps = (
    tenantID: string,
    queryClient: QueryClient,
    cloudAppID: string
  ) => {
    const cloudApps = queryClient.getQueryData(["cloudApps", tenantID]);

    if (!cloudApps) return;

    queryClient.setQueryData<Array<CloudApp>>(
      ["cloudApps", tenantID],
      (prevCloudApps) => {
        if (!prevCloudApps) return;

        return prevCloudApps.filter((cloudApp) => cloudApp.id !== cloudAppID);
      }
    );
  };

  // Returns all user's cloud app permissions
  static getCloudAppsPermissions = () => {
    const { cPermissions } = useCloudPermissions();
    const { wPermissions } = useWorkspacePermissions();

    return {
      canModify:
        cPermissions.cloud_modify_cloud_app ||
        wPermissions.workspace_modify_cloud_app,
      canInstall: wPermissions.workspace_install_cloud_app,
      canUninstall: wPermissions.workspace_uninstall_cloud_app,
      canCreate:
        cPermissions.cloud_create_cloud_app ||
        wPermissions.workspace_create_cloud_app,
      canUnpublish:
        cPermissions.cloud_unpublish_cloud_app ||
        wPermissions.workspace_unpublish_cloud_app,
    };
  };
}
